module.exports = __webpack_public_path__ + "img/user.c0e4fe8a.svg";